import { makeStyles } from '@mui/styles'
import {
  MyAccountTheme,
  MyAccountDropdownSelectClasses,
} from '@dxp-module/themes'

const dropdownSelectStyles = makeStyles<
  MyAccountTheme,
  object,
  MyAccountDropdownSelectClasses
>(
  ({ palette, spacing, transitions, breakpoints, shadows }) => ({
    root: {
      marginRight: 15,
    },
    inputRoot: {
      borderRadius: 0,
    },
    select: {
      width: '100%',
      '&:focus': {
        backgroundColor: palette.common.white,
      },
      '& legend': {
        display: 'none',
      },
      '& fieldset': {
        top: 0,
        borderRadius: 0,
      },
      '&.Mui-disabled': {
        color: palette.grey[600],
        WebkitTextFillColor: 'unset',
      },
    },
    inputAdornment: {
      margin: '0 14px',
      backgroundColor: 'transparent',
    },
    errorText: {
      margin: spacing(1),
      color: palette.error.main,
    },
    outlined: {
      borderRadius: 0,
      borderWidth: 0,
      '& $notchedOutline': {
        borderColor: palette.text.secondary,
      },
    },
    selectError: {
      borderColor: palette.error.main,
    },
    label: {
      color: palette.text.primary,
      marginBottom: 6,
      lineHeight: '20px',
    },
    disabled: {
      color: palette.grey[800],
      WebkitTextFillColor: palette.common.black,
      '& fieldset': {
        backgroundColor: palette.action.disabledBackground,
      },
    },
    item: {
      transition: transitions.create(['background', 'color']),
      color: palette.text.primary,
      backgroundColor: palette.common.white,
      '&:hover': {
        backgroundColor: palette.primary.main,

        '&:not([aria-selected])': {
          color: palette.common.white,

          [breakpoints.down(breakpoints.values.sm)]: {
            backgroundColor: palette.common.white,
            color: palette.text.primary,
          },
        },
      },
    },
    itemSelected: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    itemLabel: {
      whiteSpace: 'normal',
    },
    itemDisabled: {
      borderColor: palette.text.secondary,
      color: palette.grey[700],
      '& fieldset': {
        backgroundColor: palette.grey[200],
      },
      '&.Mui-disabled': {
        opacity: 1,
        color: 'inherit',
      },
    },
    firstMenuItem: {
      display: 'none',
    },
    labelAsterixHidden: {
      display: 'none',
    },
    list: {
      padding: 0,
    },
    listPaper: {
      boxShadow: shadows[2],
    },
    helper: {
      color: palette.error.main,
    },
    placeholder: {
      color: palette.grey[500],
    },
  }),
  { name: 'MyAccount_DropdownSelect' }
)

export default dropdownSelectStyles
